import React from 'react'
import { OUTCOME_META } from './labels'

// Chip colorido da ação/decisão (Libera, Bloqueia, Atrasa, Aprovação, ...).
// Fonte única de verdade do visual — usado nas Receitas, Regras e Decisões.
export default function OutcomeChip({ type }) {
  const m = OUTCOME_META[type] || OUTCOME_META.TAG_ONLY
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 650, padding: '2px 8px', borderRadius: 999, background: m.bg, color: m.color }}>
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: m.dot }} />{m.label}
    </span>
  )
}
